import buildStripeConnector from "./buildStripeConnector"
import config from "@/config"

const StripeDonationsConnector = buildStripeConnector(config.stripe.donationsKey)

export default StripeDonationsConnector
